import { render, staticRenderFns } from "./purchaseTrend.vue?vue&type=template&id=a1d7eb6c&scoped=true"
import script from "./purchaseTrend.vue?vue&type=script&lang=js"
export * from "./purchaseTrend.vue?vue&type=script&lang=js"
import style0 from "./purchaseTrend.vue?vue&type=style&index=0&id=a1d7eb6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1d7eb6c",
  null
  
)

export default component.exports